import type { NavigateFunction } from "react-router-dom";

// Code outside the React tree, such as an antd notification button, cannot call
// useNavigate. The router root stores its navigate function here instead.
export const navigateRef: { current: NavigateFunction | null } = { current: null };
